// src/store/renderControlSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getTodayString } from "@core/utils/date" // 날짜 포맷팅 함수
import { PatientWSerializer } from "@/types/patient"
import { EncounterBaseSerializer } from "@/types/encounter"

export interface ClickInfoState {
  menu?: string
  patientUuid?: string
  insuranceOrder?: number
  selectedDate?: string
  patientW?: PatientWSerializer | null
  encounterW?: EncounterBaseSerializer | null
  insuranceType?: string // 보험 타입 추가 --새로운 보험 생성시 전달
  insuranceUuid?: string // 보험 UUID 추가 --기존 보험 선택시 전달
}

const initialState: ClickInfoState = {
  menu: "/dashboard",
  patientUuid: "",
  insuranceOrder: 0,
  selectedDate: getTodayString(), // 오늘 날짜 자동 세팅 (예: "2025-04-28")
  patientW: null,
  encounterW: null,
  insuranceType: "일반", // 기본값 설정
}

const clickInfoSlice = createSlice({
  name: "clickInfo",
  initialState,
  reducers: {
    setClickInfo(state, action: PayloadAction<Partial<ClickInfoState>>) {
      return {
        ...state,
        ...action.payload,
      }
    },
    setPatientW(state, action: PayloadAction<Partial<PatientWSerializer>>) {
      state.patientW = {
        ...(state.patientW ?? {}),
        ...action.payload,
      }
    },
    setEncounterW(state, action: PayloadAction<Partial<EncounterBaseSerializer>>) {
      state.encounterW = {
        ...(state.encounterW ?? {}),
        ...action.payload,
      }
    },

    clearClickinfoPatient(state) {
      state.patientW = null
    },
    clearClickinfoEncounter(state) {
      state.encounterW = null
    },
    // 페이로드로 넘어온 날짜("YYYY-MM-DD")만 설정
    setSelectedDate(state, action: PayloadAction<string>) {
      state.selectedDate = action.payload
    },
    setSelectedDateToday(state) {
      state.selectedDate = getTodayString()
    },

    clearClickInfo() {
      return initialState
    },
  },
})

export const {
  setClickInfo,
  setPatientW,
  setEncounterW,
  // updateEncounterW,
  // updateEncounterWInsuranceId,
  // updateEncounterWInsuranceUuid,
  clearClickinfoPatient,
  clearClickinfoEncounter,
  clearClickInfo,
  setSelectedDate,
  setSelectedDateToday,
} = clickInfoSlice.actions

export default clickInfoSlice.reducer
